import { render, staticRenderFns } from "./_DeclinedBookingRequests.vue?vue&type=template&id=b9ce9a96&"
import script from "./_DeclinedBookingRequests.vue?vue&type=script&lang=ts&"
export * from "./_DeclinedBookingRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports